import BoardPage from '@/pages/order/layout'
import BoardIndexPage from '@/pages/order/distribution/index'

const routes = {
	path: '/orders/distribution',
	component: BoardPage,
	children: [
		{
			path: '',
			component: BoardIndexPage,
			meta: {title: 'Доска заказов'}
		}
	]
}

export default {
	routes
}



// WEBPACK FOOTER //
// ./src/routes/distribution.js